<template>
  <div>
    <WsCreate
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :primary="pageSetting.primary"
      :secondary="pageSetting.secondary"
      v-model="updateData"
    >
    </WsCreate>
  </div>
</template>

<script>
import model from "@/models/order";
export default {
  metaInfo() {
    return {
      title: "建立訂單",
    };
  },
  data: () => ({
    updateData: null,
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "stateCard",
          floors: [
            {
              fields: [
                "quotation",
                "name",
                "price",
                "relate_files",
                "relate_links",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "stateCard",
          floors: [
            {
              title: "設定",
              fields: ["deal_date", "client", "tax_type"],
            },
          ],
        },
        {
          type: "stateCard",
          floors: [
            {
              title: "狀態",
              fields: ["status"],
              hideLabelFields: ["status"],
            },
          ],
        },
      ],
    },
  }),
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style>
</style>